import numeral from 'numeral';
import isNumber from 'is-number';

export const FORMAT_MODE = {
  INTEGER: 'integer',
  TWO_DECIMAL: 'twoDecimals',
  TWO_DECIMAL_OPTIONAL: 'twoDecimalsOptional',
  FOUR_DECIMAL: 'fourDecimals',
  OTHER: 'other',
};

export const formatScore = (value, formatStr = '0.[0000]') => {
  if (isNumber(value)) {
    return numeral(value).format(formatStr);
  }
  return value;
};

export const getNumberVariant = scoreVariant => {
  if (scoreVariant === 'meds') {
    return FORMAT_MODE.FOUR_DECIMAL;
  }
  return FORMAT_MODE.TWO_DECIMAL;
  // return '';
};

export const getFormattedNumber = (value, variant) => {
  let format = '';
  switch (variant) {
    case FORMAT_MODE.INTEGER:
      format = '0,0';
      break;
    case FORMAT_MODE.TWO_DECIMAL:
      format = '0,0.00';
      break;
    case FORMAT_MODE.TWO_DECIMAL_OPTIONAL:
      format = '0,0[.]00';
      break;
    case FORMAT_MODE.FOUR_DECIMAL:
      format = '0,0.0000';
      break;
    case FORMAT_MODE.OTHER:
    default:
      format = '0,0[.]00[00]';
      /*
       *  auto fill zero to 2 or 4 decimals
       */
      if (isNumber(value)) {
        const strValue = value + '';
        if (strValue.includes('.') && strValue.split('.')[1].length >= 3) {
          format = '0,0[.]0000';
        }
      }
  }
  return isNumber(numeral(value).value()) ? numeral(value).format(format) : '-';
};
